// Mock for supports-color package to handle ESM compatibility in Jest and browser
// supports-color v11+ is ESM-only, this provides CommonJS mock

// Basic color support detection
const colorSupport = {
  level: 1,
  hasBasic: true,
  has256: false,
  has16m: false,
};

// Function version for @colors/colors compatibility
function supportsColor(stream) {
  return colorSupport;
}

// Add properties to function for direct access
supportsColor.stdout = colorSupport;
supportsColor.stderr = colorSupport;

// CommonJS export as function
module.exports = supportsColor;

// ES6 default export
module.exports.default = supportsColor;

// Named exports for direct destructuring
module.exports.stdout = colorSupport;
module.exports.stderr = colorSupport;
module.exports.supportsColor = supportsColor;
